import { Box, styled } from '@mui/material';
import React from 'react';
import {
  commonLandingPageStyles,
  sectionLandingPageStyles,
} from '../../styles';
import cx from 'classnames';
import { useIntl } from 'react-intl';
import { getPlanTypeFormatMessageProps } from '../../utils';
import { useExternalPatientsStore } from '../../hooks';

const Wrapper = styled(Box)(({ theme }) => ({
  '&.isNewTheme': {
    ...commonLandingPageStyles,
  },
  ...sectionLandingPageStyles,
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: '6rem',
  '.landing': {
    fontSize: '0.75rem',
    fontStyle: 'italic',
    color: theme.palette.grey[600],
    width: '50%',
    [theme.breakpoints.down(992)]: {
      width: '80%',
    },
  },
}));

type Props = {
  isNewTheme: boolean;
};

const Footer: React.FC<Props> = ({ isNewTheme }) => {
  const { planType } = useExternalPatientsStore();
  const intl = useIntl();
  return (
    <Wrapper
      component="section"
      className={cx({ isClassicTheme: !isNewTheme, isNewTheme })}
    >
      <Box className="landing">
        {intl.formatMessage({ id: 'signup.externalLanding.footer.oneStars' })}
        <br />
        {intl.formatMessage(
          getPlanTypeFormatMessageProps(
            'signup.externalLanding.footer.twoStars',
            planType,
          ),
        )}
        <br />
        {intl.formatMessage(
          getPlanTypeFormatMessageProps(
            'signup.externalLanding.footer.dentalCodes',
            planType,
          ),
        )}
      </Box>
    </Wrapper>
  );
};

export default Footer;
